import { withData, withUoms } from './base-composer';
import { withCompanyContacts } from './company-contacts/company-contacts';
import { withAssociationMedia, withPrimaryImage } from './media/media';
import { PropertyRef } from './property';

/**
 * Availability composer function
 * @param state
 */
export const Lease = state => {
  state = { ...state, property: PropertyRef(state.property) };
  return Object.assign(
    {},
    state,
    // composers
    withData(),
    withUoms(),
    withCompanyContacts(),
    withAssociationMedia(),
    withPrimaryImage()
  );
};
